import { Component, OnInit } from '@angular/core';
import { AccountService } from './account.service'
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';


@Component({
    //selector: 'login-form',
    providers: [AccountService],
    //templateUrl: 'app/accounts/email-confirmation.component.html',
    template: require('./email-confirmation.component.html'), 
    directives: [ROUTER_DIRECTIVES]
})
 
export class EmailConfirmationComponent implements OnInit {
    message: string;
    private sub: any;
    
    constructor(private router: Router,
        private accountService: AccountService,
        private route: ActivatedRoute) {}    
 
    ngOnInit() : void{
        
        let email: string;
        let token: any;

        this.sub = this.route.queryParams.subscribe(
            params => {
                email = params['email'];
                token = params['token'];
        });

        let data = {
	        email: email,
		    token: token
        };

        this.accountService.confirmEmail(data).
        subscribe(
            success => {
                this.message = "Confirmation of e-mail address complete.";
                    //seems no way to do this right now, not sure if needed
  					//$location.search('email', undefined);
  					//$location.search('token', undefined);
                },
            error => this.message = "Failed to confirm e-mail. " + error);
    }
}



/** WEBPACK FOOTER **
 ** ./app/accounts/email-confirmation.component.ts
 **/